import {
    dateFormat
} from './filters';

export default {
    'dateFormat': dateFormat
};